import React from 'react'
import { Image, ImageBackground } from 'react-native'

import { images } from '@zet/assets/images'
import { useModal } from '@zet/common/hooks/useModal'
import { Icon } from '@zet/design-system/index'
import { Stack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { appVideos } from '@zet/utils/Constants'
import { VideoBannerProps } from '@zet/utils/interface'
import { navigateTo, navigationRef } from '@zet/utils/navigation'

const thumbnail = images?.backgroundPersons

export default function VideoBanner({
  image = thumbnail,
  videoId,
  isPressable,
  eventName,
  eventPayload,
  videoData = null,
  imageStyle,
  imageClasses = '',
  resizeMode = 'stretch',
}: VideoBannerProps) {
  const { openModal } = useModal()

  return (
    <Stack>
      <ImageBackground
        source={typeof image !== typeof '' ? image : { uri: image }}
        imageStyle={{ borderRadius: 6, ...imageStyle }}
        className={`h-52 items-center justify-center ${imageClasses}`}
        resizeMode={resizeMode}
      >
        {isPressable && (
          <Pressable
            className="absolute left-3 top-3 rounded p-1 active:bg-red-200"
            style={{ backgroundColor: 'rgba(236, 239, 245, 0.1)' }}
            onPress={() =>
              navigationRef.canGoBack()
                ? navigationRef?.goBack()
                : navigateTo('HomeView')
            }
          >
            <Icon type="ArrowLeft" color="#fff" />
          </Pressable>
        )}
        <Pressable
          onPress={() => {
            openModal('YoutubeVideoModal', {
              videoId: videoId || appVideos.zetPlaceHolder.videoId,
              videoData: videoData,
            })
          }}
          eventName={eventName}
          eventPayload={eventPayload}
        >
          <Image source={images.play} style={{ height: 60, width: 60 }} />
        </Pressable>
      </ImageBackground>
    </Stack>
  )
}
